import React from 'react'
import { RobotoTypo } from '../../../utils/Typographies'
import { Box, IconButton } from '@mui/material'
import { useSelector } from 'react-redux'
import { ReactComponent as RightArrow } from "../../../assets/StudyingAboard/RightSideArrow.svg";
import { useNavigate } from 'react-router-dom';

function ConsultationCard({image, title, description, Date, tags = [], activity}) {
    const language = useSelector((state) => state.language.language);
    const navigate = useNavigate();

    console.log(language)
  return (
    <Box sx={{position : 'relative', padding : '25px', width: { xs: "70%", sm: "40%", md: "40%", lg: "25%" }, border : '0px solid #E0E0E0', borderRadius : '30px', backgroundColor : 'white', marginTop : '40px'}}>
        {image?.filePath && (
  <img
    style={{ height: "170px", width: "100%", objectFit: "cover", borderRadius: '16px' }}
    src={`${process.env.REACT_APP_FILE_URL1}${image.filePath}`}
    alt="Consultation"
  />
)}

        <Box sx={{mt : '16px'}}>
            <RobotoTypo style={{fontWeight: 'bold', fontSize : '20px', color: "#003B5C"}}>{title?.[language]}</RobotoTypo>
        </Box>
        <Box sx={{ mt: "16px" }}>
  <RobotoTypo
    sx={{
      fontWeight: "normal",
      fontSize: "18px",
      color: "#242424",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    }}
  >
    {description?.[language]}
  </RobotoTypo>
</Box>
        <Box sx={{mt : '16px', display : 'flex', gap : '10px', flexWrap : 'wrap'}}>
          
            {tags.map((tag, i) => (
                <RobotoTypo key={i} style={{padding : '6px 14px', border : '1px solid #177D84', color : '#177D84', borderRadius : '40px'}}>{tag}</RobotoTypo>
            ))}
            
        </Box>
        <Box sx={{mt : 6}}>

        </Box>

        {/* <Box sx={{mt : '16px', display : 'flex', justifyContent : 'flex-end', alignItems : 'center'}}> */}
            <IconButton 
                      onClick={() => navigate(`/consultation/${activity._id}`, { state: { activity } })}
                      sx={{
                        backgroundColor: "#177D84",
                        position : 'absolute',
                        bottom : -0,
                        right : 0,
                        mt : 3,
                        mr : 2.5,
                        mb: 2,
                        padding: "14px",
                        ":hover": {
                          bgcolor: "#177D84",
                        },
                      }}
                    >
                      {" "}
                      <RightArrow />{" "}
                    </IconButton>
        {/* </Box> */}
        
    </Box>
  )
}

export default ConsultationCard